declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";

import { Router, ActivatedRoute } from '@angular/router';




declare var require: any;


import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { routerTransition } from '../../../../../../src/app/ncs/animations/router.animations';
import { NgbAddBill } from './modal/addbill.modal';
import { NgbPayBillModal } from './paybill.modal';





@Component({
  selector: 'billview',
  templateUrl: './billview.component.html',
  styleUrls: ['./billview.component.scss']
  , animations: [routerTransition()]
})

export class BillViewComponent implements OnInit {




  public ActorCode: number = 0;
  public FormattedCode: number = 0;
  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsExpand: boolean = true;
  public Showarrow: boolean = false;
  public ShowList: boolean = true;
  public ShowPatientDetails: boolean = false;
  public receipt: boolean = true;
  public opbilling: boolean = false;
  public isRequesting: boolean = false;
  public FormattedCodedata: string;
  public billdetails1: boolean = false;
  public billdetails2: boolean = false;

  constructor(private router: Router,

    private modalService: NgbModal,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {

    //this.FormattedCodedata = this.route.snapshot.paramMap.get('Formattedcodedata');
    //alert(this.FormattedCodedata);
  }







  BackToProfile() {
    this.ShowList = true;
    this.ShowPatientDetails = false;
    this.Showarrow = false;
  }
  billdetails() {
    this.billdetails1 = true;
    this.billdetails2 = true;
  }

  docedit() {

    const modalRef = this.modalService.open(NgbAddBill,
      {
        centered: true,
        size: "lg"
      })


  }
  CancelNewOperation() {

    this.ShowList = true;
  }
  back() {
    this.receipt = false;
    this.opbilling = true;
    this.router.navigate(['/healins/opbilling']);
    //this.router.navigate.['/healins/opbilling'];
  }
  payment() {
    const modalRef = this.modalService.open(NgbPayBillModal,
      {
        centered: true,
        size: "lg"
      })
  }






}
